export default __webpack_public_path__ + "static/media/logotype.223c8e47.svg";